import React, { useState, useEffect } from "react";
import Header from "../../Core/Header";
import axios from "axios";
import { employeeRoleApi, EmployeeRoleApi, get_EmployeeRole, getMenuSubmenu, addNewRole, getEmployeeRolePermission } from "../../Services/Operations/ProductAPI";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Section } from "../../Core/Section";
import { useSelector } from "react-redux";


const EmployeeRole = () => {
  const [EmployeeRole, setEmployeeRole] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cartUpdated, setEmployeeRoleUpdated] = useState(false);
  const [formData, setFormData] = useState({ employeeRoleName: "" });
  const [employeeAssignList, setEmployeeAssignList] = useState([]);
  const [rolePermission, setRolePermission] = useState([]);
  const token = useSelector((state) => state.user.token);
  const [newRole, setNewRole] = useState(false);

  const [menus, setMenus] = useState([]);
  const [allSubmenus, setAllSubmenus] = useState([]);
  const [allPermission, setAllPermission] = useState([]);

  const [newRoleName, setNewRoleName] = useState("");
  const [newDesc, setNewDesc] = useState("");
  const [alowedMenus, setAllowedMenus] = useState([]);
  const [alowedSubMenus, setAllowedSubMenus] = useState([]);

  console.log("token : ", token);
  const fetchEmployeeRole = async () => {
    try {
      const response = await get_EmployeeRole(token);
      console.log("EmployeeAssign list:", response.data);
      setEmployeeAssignList(response.data);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const fetchEmployeeRolePermission = async () => {
    try {
      const response = await getEmployeeRolePermission(token);
      console.log("Employee role permission:", response.data);
      setRolePermission(response.data);
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    let data = {
      categoryId: 3,
      employeeRoleName: newRoleName,
      menus: alowedMenus,
      submenus: alowedSubMenus,
    };

    try {
      const response = await employeeRoleApi(data, token);
      console.log("EmployeeRole Added Response:", response);

      if (response.status === 200) {
        toast.success("EmployeeRole added successfully!");
        setFormData({ EmployeeRolePercent: "" });
        fetchEmployeeRole();
        setAllowedMenus([]);
        setAllowedSubMenus([]);
        setNewRoleName("");
        setNewRole(false);
      } else {
        toast.error(response.data.errors?.message || "Failed to add EmployeeRole.");
      }
    } catch (error) {
      console.error("Error adding EmployeeRole:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    fetchEmployeeRolePermission();
    fetchEmployeeRole();
  }, []);

  useEffect(() => {
    const handleGetMenus = async () => {
      try {
        const response = await getMenuSubmenu(token);
        console.log("list of menus", response);
        if (response.status === 200) {
          setMenus(response.data.menus);
          setAllPermission(response.data.allPermissions);
          const combinedSubs = response.data.menus.flatMap((menu) => menu.submenus);
          setAllSubmenus(combinedSubs);
          console.log("all sub menus", combinedSubs);
        }
      } catch (error) {
        console.log(error);
      }
    };

    handleGetMenus();
  }, []);

  const hasPermission1 = (menuId, permissionId) => {
    // to check if present or not
    const menu = alowedMenus.find((m) => m.menuId === menuId);
    if (!menu) return false;

    return menu.permissionIds.includes(permissionId);
  };
  const hasPermission2 = (submenuId, permissionId) => {
    // to check if present or not
    const menu = alowedSubMenus.find((m) => m.submenuId === submenuId);
    if (!menu) return false;

    return menu.permissionIds.includes(permissionId);
  };

  const handleAddMenu = async (menuId, permissionId) => {
    try {
      setAllowedMenus((prev) => {
        const index = prev.findIndex((item) => item.menuId === menuId);

        if (index !== -1) {
          // --- Menu exists: update its permissionIds ---
          const updated = [...prev];
          const perms = new Set(updated[index].permissionIds);

          // toggle permission
          if (perms.has(permissionId)) {
            perms.delete(permissionId);
          } else {
            perms.add(permissionId);
          }

          updated[index].permissionIds = Array.from(perms);
          return updated;
        } else {
          // --- Menu NOT exists: add new menu entry ---
          return [...prev, { menuId, permissionIds: [permissionId] }];
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddSubMenu = async (submenuId, menuId, permissionId) => {
    const index = alowedMenus.find((item) => item.menuId === menuId);

    if (!index) {
      console.log("user not alowed");
      handleAddMenu(menuId, permissionId);
    }

    console.log("list", submenuId, menuId, permissionId, index);

    try {
      setAllowedSubMenus((prev) => {
        const index = prev.findIndex((item) => item.submenuId === submenuId);

        if (index !== -1) {
          // --- Menu exists: update its permissionIds ---
          const updated = [...prev];
          const perms = new Set(updated[index].permissionIds);

          // toggle permission
          if (perms.has(permissionId)) {
            perms.delete(permissionId);
          } else {
            perms.add(permissionId);
          }

          updated[index].permissionIds = Array.from(perms);
          return updated;
        } else {
          // --- Menu NOT exists: add new menu entry ---
          return [...prev, { submenuId, permissionIds: [permissionId] }];
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleNewRoleSubmit = async () => {
    try {
      console.log(newRoleName, newDesc, alowedMenus, alowedSubMenus);
      let data = {
        categoryname: newRoleName,
        description: newDesc,
        menus: alowedMenus,
        submenus: alowedSubMenus,
        token,
      };
      const response = await addNewRole(data);
      console.log("new role add", response);
      if (response.status === 200) {
        toast.success("New user role Added");

        setNewRole(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const permLabel = (id) => (id === 1 ? "Add" : id === 2 ? "View" : id === 3 ? "Update" : "Delete");
  const permIcon = (id) =>
    id === 1 ? "fa-plus" : id === 2 ? "fa-eye" : id === 3 ? "fa-pencil" : "fa-trash";

  return (
    <div id="main_content">
      <Header />
      <div className="page er-page">
        <Section />

        {/* ================= TITLE ================= */}
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center er-title-bar">
              <div className="header-action">
                <h1 className="page-title er-title">EmployeeRoles</h1>
                <ol className="breadcrumb page-breadcrumb er-crumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    EmployeeRoles
                  </li>
                </ol>
              </div>
              <span className="er-title-icon">
                <i className="fa fa-id-badge" />
              </span>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Student-add">
                <div className="row clearfix">
                  <div className=" col-md-12 col-sm-12">
                    {/* ================= ADD ROLE CARD ================= */}
                    <div className="card er-card">
                      <div className="card-header er-card-head">
                        <h3 className="card-title">
                          <i className="fa fa-shield" /> Basic Information
                        </h3>
                        <div className="card-options ">
                          <a href="#" className="card-options-collapse" data-toggle="card-collapse">
                            <i className="fa fa-chevron-up" />
                          </a>
                          <a href="#" className="card-options-remove" data-toggle="card-remove">
                            <i className="fa fa-times" />
                          </a>
                        </div>
                      </div>
                      <form className="card-body" onSubmit={(e) => e.preventDefault()}>
                        <div className="er-add-row">
                          <div>
                            <p className="er-add-title">Add New Employee Role</p>
                            <p className="er-add-sub">Name the role, then choose what it can do.</p>
                          </div>
                          {!newRole ? (
                            <button
                              type="button"
                              className="btn btn-success btn-circle er-toggle er-toggle-add"
                              onClick={() => setNewRole(true)}
                              title="Add new role"
                            >
                              +
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-danger btn-circle er-toggle er-toggle-close"
                              onClick={() => setNewRole(false)}
                              title="Close"
                            >
                              -
                            </button>
                          )}
                        </div>

                        {newRole && (
                          <div className="er-form">
                            <label className="er-label">
                              <i className="fa fa-tag" /> Role name
                            </label>
                            <input
                              className="er-input"
                              value={newRoleName}
                              onChange={(e) => setNewRoleName(e.target.value)}
                              placeholder="Enter Role Name"
                            />

                            <div className="er-grid">
                              {/* ---- Menus ---- */}
                              <div className="er-col">
                                <p className="er-col-title">
                                  <i className="fa fa-bars" /> Select Allowed Menus
                                </p>
                                <div className="er-list">
                                  {menus.map((category) => (
                                    <div key={category.id} className="er-row">
                                      <p className="er-row-name">{category.manuName}</p>
                                      <span className="er-chips">
                                        {allPermission.map((i) => (
                                          <p
                                            key={i.id}
                                            onClick={() => handleAddMenu(category.id, i.id)}
                                            className={`er-chip ${hasPermission1(category.id, i.id) ? "is-on" : ""}`}
                                          >
                                            <i className={`fa ${permIcon(i.id)}`} /> {permLabel(i.id)}
                                          </p>
                                        ))}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>

                              {/* ---- Submenus ---- */}
                              <div className="er-col">
                                <p className="er-col-title">
                                  <i className="fa fa-sitemap" /> Select Allowed SubMenus
                                </p>
                                <div className="er-list">
                                  {allSubmenus.map((category) => (
                                    <div key={category.id} className="er-row">
                                      <p className="er-row-name">{category.submenuName}</p>
                                      <span className="er-chips">
                                        {allPermission.map((i) => (
                                          <p
                                            key={i.id}
                                            onClick={() => handleAddSubMenu(category.id, category.menuId, i.id)}
                                            className={`er-chip ${hasPermission2(category.id, i.id) ? "is-on" : ""}`}
                                          >
                                            <i className={`fa ${permIcon(i.id)}`} /> {permLabel(i.id)}
                                          </p>
                                        ))}
                                      </span>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>

                            <p onClick={handleSubmit} className="er-submit">
                              <i className="fa fa-check-circle" /> Submit
                            </p>
                          </div>
                        )}
                      </form>

                      {/* ================= EXISTING ROLES ================= */}
                      <div className="er-roles">
                        <p className="er-roles-title">
                          <i className="fa fa-users" /> Employee Roles
                          <span className="er-count">{rolePermission.length}</span>
                        </p>
                        <div className="er-roles-grid">
                          {rolePermission.map((role, index) => (
                            <div className="er-role" key={index}>
                              <div className="er-role-top">
                                <span className="er-role-index">{index + 1}</span>
                                <span className="er-role-name">{role.roleName}</span>
                              </div>
                              <p className="er-role-label">Allowed Permission Area:</p>
                              <span className="er-tags">
                                {role.menus?.length > 0 &&
                                  role.menus?.map((i, k) => (
                                    <p className="er-tag" key={k}>
                                      {i.name}
                                    </p>
                                  ))}
                              </span>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="section-body">
          <footer className="footer er-footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025 <a href="">Technology support By - Siance Software Pvt Ltd</a>.
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};
export default EmployeeRole;
